var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"dokumentLogModal",attrs:{"size":"xl","ok-only":"","scrollable":"","hide-backdrop":"","title":"Log za dokument"},on:{"ok":_vm.handleOK}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('b-table-lite',{attrs:{"items":_vm.items}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }